<h3>{{'NavMenu.FindDistrictoffice'|translate}}</h3>

<div class="container-fluid">
  <app-findProperty [color]="'#3165b1'" [title]="'ContactAssessor.District' | translate" [imgItem]="false"  (ParcelItem)="getAddress($event)"></app-findProperty>
</div>


@if (parcel) {
  <div>
    <div class="row my-4 clearfix">
      <h4 class="p-md-3">{{parcel.DistrictOffice}}</h4>
    </div>
    <div class="row my-4">
      <div class="col-md-4 pr-md-3 clearfix">
        <p class="float-left"><strong>District</strong></p>
        <div>
          <p>{{parcel.DistrictOffice}}</p>
          <p class="border-item">{{parcel.OfficeStreet}}</p>
          <p>{{parcel.OfficeCity}} {{parcel.OfficeZipCode}}</p>
        </div>
      </div>
      <div class="col-md-4 pr-md-3">
        <p><strong>Phone:</strong> <span class="float-end">{{parcel.OfficePhone}}</span></p>
        <p class="border-item"><strong>Toll Free:</strong> <span class="float-end">{{parcel.OfficeTollFree}}</span></p>
        <p><strong>Hours:</strong> <span class="float-end">{{parcel.OfficeHours}}</span></p>
      </div>
      <div class="col-md-4 pr-md-3">
        <p><strong>Region:</strong> <span class="float-end">{{parcel.Region}}</span></p>
        <p class="border-item"><strong>Cluster:</strong> <span class="float-end">{{parcel.Cluster}}</span></p>
      </div>
    </div>
  </div>
}
